import {Component, Input, OnInit} from '@angular/core';
import {Order} from '../../../services/order';
import {Debtor} from '../../../services/debtor';
import {Creditor} from '../../../services/creditor';
import {ORDER_FIELDS_IDS} from '../../../../config/constants-10-4';

@Component({
    selector: 'app-dates-and-info',
    templateUrl: './dates-and-info.html',
    styleUrls: ['./dates-and-info.scss']
})
export class DatesAndInfoComponent implements OnInit {

    public readonly ORDER_FIELDS_IDS = ORDER_FIELDS_IDS;

    @Input() order: Order;
    @Input() debtor: Debtor;
    @Input() creditor: Creditor;

    constructor() {
    }

    ngOnInit(): void {
    }
}
